import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link as RouterLink } from 'react-router-dom';
import {
  Container,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert,
  Link, // Import Link from MUI for styling consistency
  Box,
  Rating
} from '@mui/material';
import { API_URL } from '../config';
import { formatInTimeZone } from 'date-fns-tz';

function EvaluationList() {
  const [evaluations, setEvaluations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvaluations = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${API_URL}/api/evaluations`);
        setEvaluations(response.data);
      } catch (err) {
        console.error("Error fetching evaluations:", err);
        setError(err.response?.data?.error || err.message || 'Failed to fetch evaluations');
      } finally {
        setLoading(false);
      }
    };

    fetchEvaluations();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom component="h1">
        評估結果列表
      </Typography>

      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}>
          <CircularProgress />
        </Box>
      )}

      {error && (
        <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>
      )}

      {!loading && !error && (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: 600 }}>
            <Table stickyHeader aria-label="evaluation list table">
              <TableHead>
                <TableRow>
                  <TableCell>評估 ID</TableCell>
                  <TableCell>對話 ID</TableCell>
                  <TableCell>場景</TableCell>
                  <TableCell>提交時間</TableCell>
                  <TableCell align="center">整體評分</TableCell>
                  <TableCell>提交者 ID</TableCell>
                  <TableCell>操作</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {evaluations.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">沒有找到評估記錄</TableCell>
                  </TableRow>
                ) : (
                  evaluations.map((evaluation) => (
                    <TableRow
                      hover
                      key={evaluation.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {evaluation.id}
                      </TableCell>
                      <TableCell>
                        {evaluation.conversation_id ? (
                          <Link component={RouterLink} to={`/history?view=${evaluation.conversation_id}`} underline="hover">
                            {evaluation.conversation_id}
                          </Link>
                        ) : (
                          'N/A'
                        )}
                      </TableCell>
                      <TableCell>{evaluation.scenario_title || '未知場景'}</TableCell>
                      <TableCell>
                        {evaluation.created_at ? formatInTimeZone(evaluation.created_at, 'Asia/Taipei', 'yyyy-MM-dd HH:mm:ss') : 'N/A'}
                      </TableCell>
                      <TableCell align="center">
                        {evaluation.b3_rating !== null ? (
                            <Rating value={evaluation.b3_rating} readOnly size="small" />
                        ) : (
                            '-'
                        )}
                      </TableCell>
                      <TableCell>{evaluation.member_id || 'N/A'}</TableCell>
                      <TableCell>
                        <Link component={RouterLink} to={`/evaluations/${evaluation.id}`} underline="hover">
                          查看詳情
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
    </Container>
  );
}

export default EvaluationList; 